export enum SelectMode {
  single = 'single',
  multiple = 'multiple'
}
